module.exports = __webpack_public_path__ + "img/gch4@2x.bd758047.png";